import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightbulbLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 32,
	viewBox: "0 0 21 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13999_65688)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M6.43895 23.9997C6.68732 23.894 6.88602 23.1752 5.69384 21.1457C4.20361 18.6088 1.71989 12.2665 2.96175 10.0468C4.20361 7.82699 6.93569 2.75321 9.66778 3.38743C12.3999 4.02165 16.1254 5.92425 16.6222 7.50981C17.1189 9.09536 19.6026 13.5349 17.6157 16.0718C15.6287 18.6087 14.3868 21.4627 14.1385 22.414C13.9398 23.1751 9.25383 23.7882 6.93569 23.9997",
					stroke: "#F38D1C",
					strokeWidth: .5
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.8673 2.01953C15.5687 1.6615 20.3307 6.27198 20.3308 11.9941C20.3308 14.4204 19.4621 16.7592 17.8871 18.5814C17.6502 18.8554 17.4179 19.1231 17.2005 19.3731C16.3551 20.345 15.8073 21.5404 15.6313 22.8164C15.563 23.2666 15.3146 23.6624 14.9552 23.9199H6.049C5.6631 23.6294 5.40591 23.1545 5.31328 22.5443C5.14634 21.4443 4.66566 20.4168 3.94124 19.5723C3.65946 19.2438 3.34191 18.871 3.01 18.4766C1.40905 16.5722 0.574998 14.1413 0.662498 11.6302C0.840424 6.55563 4.88287 2.33356 9.8673 2.01953Z",
				fill: "url(#paint0_linear_13999_65688)",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.87012 2.06934C15.5418 1.71317 20.2811 6.29986 20.2812 11.9941C20.2812 14.4085 19.4166 16.7358 17.8496 18.5488C17.6128 18.8227 17.3804 19.09 17.1631 19.3398C16.3117 20.3188 15.7595 21.5232 15.582 22.8086C15.5165 23.2405 15.2791 23.6201 14.9365 23.8701H6.06738C5.70114 23.5885 5.45253 23.1312 5.3623 22.5371C5.19394 21.4277 4.70967 20.3913 3.97949 19.54C3.6978 19.2117 3.37964 18.8387 3.04785 18.4443C1.45507 16.5496 0.625822 14.1306 0.712891 11.6318C0.890007 6.58244 4.91224 2.38186 9.87012 2.06934Z",
				stroke: "url(#paint1_linear_13999_65688)",
				strokeOpacity: .48,
				strokeWidth: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.1746 30.667C11.9746 30.667 11.8175 30.832 11.7647 31.0249C11.6107 31.5875 11.1028 32.0003 10.5 32.0003C9.89629 32.0003 9.38778 31.5863 9.23465 31.0224C9.18261 30.8308 9.02653 30.667 8.82797 30.667C8.63762 30.6669 8.45753 30.5968 8.32233 30.4691C7.92435 30.093 8.14875 29.4234 8.69295 29.3631L12.2066 28.9736C12.3505 28.957 12.4522 28.8349 12.4348 28.7002C12.4173 28.564 12.2848 28.4689 12.1451 28.484L7.16293 29.0364C7.02977 29.0511 6.89191 28.9728 6.89191 28.8389C6.89191 28.4216 7.20576 28.071 7.62053 28.0251L13.5759 27.3657C13.8588 27.3344 14.1062 27.5558 14.1062 27.8405C14.1062 28.0841 13.9228 28.2887 13.6806 28.3153L12.9558 28.3949C12.8119 28.4114 12.7097 28.5336 12.727 28.6683C12.743 28.7935 12.8556 28.8857 12.9866 28.8857C12.9966 28.8857 13.0067 28.8845 13.0167 28.8844L14.0343 28.7717C14.0744 28.7672 14.1094 28.7986 14.1094 28.8389C14.1079 29.0175 14.0307 29.1922 13.8985 29.3174L12.6809 30.4691C12.5456 30.5969 12.3651 30.6669 12.1746 30.667ZM13.7468 24.6682C13.9463 24.6683 14.1081 24.83 14.1081 25.0296C14.1081 25.2138 13.9696 25.3685 13.7865 25.3888L9.53229 25.8597C9.38844 25.8763 9.28674 25.9985 9.30414 26.1331C9.32014 26.2583 9.43214 26.3506 9.56305 26.3506C9.57323 26.3506 9.58363 26.3493 9.59381 26.3493L13.5776 25.9075C13.8606 25.8761 14.1081 26.0976 14.1081 26.3824C14.1081 26.6259 13.9249 26.8305 13.6829 26.8573L7.42325 27.5504C7.1406 27.5817 6.89333 27.3608 6.89276 27.0764C6.89228 26.8324 7.07571 26.6272 7.31825 26.6004L7.82437 26.5446C7.9684 26.5281 8.07062 26.4053 8.05316 26.2705C8.03559 26.1345 7.90308 26.0413 7.76349 26.055L7.66886 26.0655C7.25361 26.1113 6.89062 25.7862 6.89062 25.3684C6.89062 24.981 7.20468 24.667 7.59204 24.6671L13.7468 24.6682Z",
				fill: "url(#paint2_linear_13999_65688)",
				style: { mixBlendMode: "multiply" }
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12.7776 9.59961C13.0196 9.59961 13.163 9.85135 13.3025 10.0944C13.3627 10.2 13.4765 10.3954 13.5326 10.4134C13.6091 10.4369 13.6883 10.3553 13.8126 10.2207C13.9576 10.0652 14.1558 9.8513 14.4388 9.92904C14.6616 9.99154 14.7478 10.1833 14.797 10.3652L14.9668 9.98437C15.0339 9.83178 15.2087 9.76393 15.3603 9.83333C15.5107 9.90142 15.576 10.0803 15.509 10.2331L11.8234 18.5111C11.9805 18.7152 12.072 18.9705 12.072 19.2454V20.4857C12.653 20.7898 13.0281 21.3994 13.0282 22.0729L13.0276 23.0306L13.0244 23.0299V23.7376L8.09608 23.737V21.9167C8.14919 21.3064 8.50843 20.7667 9.04393 20.4863V19.2454C9.04399 18.972 9.13547 18.7151 9.29258 18.5111L5.60438 10.2376C5.5374 10.0849 5.60272 9.90532 5.75306 9.83724C5.90482 9.7678 6.08021 9.83755 6.1472 9.98893L6.31639 10.3678C6.36559 10.1859 6.45051 9.99414 6.67335 9.93164C6.95356 9.85393 7.15458 10.0664 7.29948 10.2233C7.42381 10.3565 7.50447 10.4387 7.57826 10.4167C7.63431 10.4 7.74817 10.2026 7.80833 10.097C7.94774 9.854 8.09126 9.60286 8.3332 9.60286C8.57509 9.60436 8.71874 9.85532 8.85679 10.0983C8.9169 10.2038 9.03013 10.401 9.08622 10.4193C9.12451 10.4109 9.2214 10.2842 9.27336 10.2161C9.4087 10.0384 9.58147 9.82054 9.83027 9.88997C10.0817 9.9609 10.1158 10.2374 10.1417 10.4609C10.1472 10.4956 10.1528 10.5414 10.1597 10.5872C10.1733 10.5567 10.1872 10.5263 10.1981 10.5013C10.2199 10.4542 10.2374 10.4139 10.2565 10.3737V10.1126C10.2565 9.94466 10.3905 9.80938 10.5545 9.80924C10.7199 9.80924 10.8525 9.94597 10.8525 10.1126V10.3737C10.8716 10.4139 10.8909 10.4528 10.9114 10.5C10.9237 10.525 10.9375 10.5554 10.9512 10.5872C10.9593 10.5415 10.965 10.4943 10.9691 10.4596C10.9964 10.2374 11.0291 9.95955 11.2806 9.88867C11.5279 9.81926 11.7002 10.0385 11.8368 10.2148C11.8902 10.2815 11.9861 10.4083 12.0285 10.4167C12.0818 10.4 12.1939 10.2013 12.254 10.0957C12.3921 9.8513 12.5357 9.59966 12.7776 9.59961ZM9.50728 21.0553C9.07675 21.2068 8.78694 21.6167 8.78694 22.0736V22.8841H12.3277V22.0736C12.3277 21.6152 12.0381 21.2067 11.6074 21.0553C11.5896 21.0484 11.5732 21.0371 11.5568 21.0273H9.5579C9.54154 21.037 9.52637 21.0484 9.50728 21.0553ZM10.0706 18.7897C9.87516 18.8564 9.74376 19.0372 9.74376 19.2454V20.5299H11.3722V19.2454C11.3722 19.0385 11.2409 18.8578 11.0454 18.7897H10.0706ZM10.5577 13.7357C10.4319 13.7357 10.329 13.8397 10.3289 13.9674H10.3276V18.1855H10.7858V13.9674C10.7857 13.8398 10.6833 13.7358 10.5577 13.7357ZM8.33064 9.95378C8.28416 9.97183 8.17291 10.1659 8.11274 10.2715C7.9856 10.4937 7.86661 10.7023 7.67247 10.7565C7.39097 10.8327 7.19121 10.6203 7.04634 10.4648C6.92062 10.3302 6.83462 10.2493 6.76628 10.2715C6.69383 10.2923 6.66364 10.4022 6.62401 10.5827C6.60486 10.6716 6.58171 10.7734 6.54069 10.8678L9.62776 17.8008V13.9687C9.62787 13.5536 9.89332 13.2051 10.2597 13.0788V11.0521C10.2159 11.0771 10.1678 11.087 10.1091 11.0703C9.85749 10.9995 9.82357 10.723 9.79759 10.4993C9.78667 10.4134 9.76876 10.2555 9.73607 10.2259C9.70189 10.2356 9.60473 10.3623 9.55278 10.4303C9.41745 10.6081 9.246 10.8259 8.99586 10.7565C8.80189 10.7022 8.68323 10.4922 8.55751 10.2715C8.49744 10.1675 8.38677 9.97377 8.33064 9.95378ZM12.7725 9.95247C12.7274 9.97051 12.6167 10.1646 12.5565 10.2702C12.4308 10.491 12.3116 10.701 12.1175 10.7552C11.8689 10.8246 11.6979 10.6054 11.5613 10.429C11.508 10.3624 11.412 10.2356 11.3696 10.2272C11.3451 10.2536 11.326 10.4133 11.3164 10.498C11.2891 10.7203 11.2559 10.9982 11.0043 11.069C10.9457 11.0856 10.8981 11.077 10.8544 11.0521V13.0775C11.2206 13.2053 11.4856 13.5537 11.4856 13.9674V17.7995L14.5701 10.8665C14.5305 10.7721 14.506 10.6703 14.4868 10.5814C14.4472 10.4009 14.4184 10.291 14.3446 10.2702C14.2708 10.248 14.1902 10.3289 14.0645 10.4635C13.9196 10.619 13.7212 10.8328 13.4384 10.7552C13.2456 10.701 13.1252 10.491 12.9994 10.2702C12.9406 10.1661 12.8286 9.97097 12.7725 9.95247Z",
					fill: "url(#paint3_linear_13999_65688)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_g_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12.7776 9.59961C13.0196 9.59961 13.163 9.85135 13.3025 10.0944C13.3627 10.2 13.4765 10.3954 13.5326 10.4134C13.6091 10.4369 13.6883 10.3553 13.8126 10.2207C13.9576 10.0652 14.1558 9.8513 14.4388 9.92904C14.6616 9.99154 14.7478 10.1833 14.797 10.3652L14.9668 9.98437C15.0339 9.83178 15.2087 9.76393 15.3603 9.83333C15.5107 9.90142 15.576 10.0803 15.509 10.2331L11.8234 18.5111C11.9805 18.7152 12.072 18.9705 12.072 19.2454V20.4857C12.653 20.7898 13.0281 21.3994 13.0282 22.0729L13.0276 23.0306L13.0244 23.0299V23.7376L8.09608 23.737V21.9167C8.14919 21.3064 8.50843 20.7667 9.04393 20.4863V19.2454C9.04399 18.972 9.13547 18.7151 9.29258 18.5111L5.60438 10.2376C5.5374 10.0849 5.60272 9.90532 5.75306 9.83724C5.90482 9.7678 6.08021 9.83755 6.1472 9.98893L6.31639 10.3678C6.36559 10.1859 6.45051 9.99414 6.67335 9.93164C6.95356 9.85393 7.15458 10.0664 7.29948 10.2233C7.42381 10.3565 7.50447 10.4387 7.57826 10.4167C7.63431 10.4 7.74817 10.2026 7.80833 10.097C7.94774 9.854 8.09126 9.60286 8.3332 9.60286C8.57509 9.60436 8.71874 9.85532 8.85679 10.0983C8.9169 10.2038 9.03013 10.401 9.08622 10.4193C9.12451 10.4109 9.2214 10.2842 9.27336 10.2161C9.4087 10.0384 9.58147 9.82054 9.83027 9.88997C10.0817 9.9609 10.1158 10.2374 10.1417 10.4609C10.1472 10.4956 10.1528 10.5414 10.1597 10.5872C10.1733 10.5567 10.1872 10.5263 10.1981 10.5013C10.2199 10.4542 10.2374 10.4139 10.2565 10.3737V10.1126C10.2565 9.94466 10.3905 9.80938 10.5545 9.80924C10.7199 9.80924 10.8525 9.94597 10.8525 10.1126V10.3737C10.8716 10.4139 10.8909 10.4528 10.9114 10.5C10.9237 10.525 10.9375 10.5554 10.9512 10.5872C10.9593 10.5415 10.965 10.4943 10.9691 10.4596C10.9964 10.2374 11.0291 9.95955 11.2806 9.88867C11.5279 9.81926 11.7002 10.0385 11.8368 10.2148C11.8902 10.2815 11.9861 10.4083 12.0285 10.4167C12.0818 10.4 12.1939 10.2013 12.254 10.0957C12.3921 9.8513 12.5357 9.59966 12.7776 9.59961ZM9.50728 21.0553C9.07675 21.2068 8.78694 21.6167 8.78694 22.0736V22.8841H12.3277V22.0736C12.3277 21.6152 12.0381 21.2067 11.6074 21.0553C11.5896 21.0484 11.5732 21.0371 11.5568 21.0273H9.5579C9.54154 21.037 9.52637 21.0484 9.50728 21.0553ZM10.0706 18.7897C9.87516 18.8564 9.74376 19.0372 9.74376 19.2454V20.5299H11.3722V19.2454C11.3722 19.0385 11.2409 18.8578 11.0454 18.7897H10.0706ZM10.5577 13.7357C10.4319 13.7357 10.329 13.8397 10.3289 13.9674H10.3276V18.1855H10.7858V13.9674C10.7857 13.8398 10.6833 13.7358 10.5577 13.7357ZM8.33064 9.95378C8.28416 9.97183 8.17291 10.1659 8.11274 10.2715C7.9856 10.4937 7.86661 10.7023 7.67247 10.7565C7.39097 10.8327 7.19121 10.6203 7.04634 10.4648C6.92062 10.3302 6.83462 10.2493 6.76628 10.2715C6.69383 10.2923 6.66364 10.4022 6.62401 10.5827C6.60486 10.6716 6.58171 10.7734 6.54069 10.8678L9.62776 17.8008V13.9687C9.62787 13.5536 9.89332 13.2051 10.2597 13.0788V11.0521C10.2159 11.0771 10.1678 11.087 10.1091 11.0703C9.85749 10.9995 9.82357 10.723 9.79759 10.4993C9.78667 10.4134 9.76876 10.2555 9.73607 10.2259C9.70189 10.2356 9.60473 10.3623 9.55278 10.4303C9.41745 10.6081 9.246 10.8259 8.99586 10.7565C8.80189 10.7022 8.68323 10.4922 8.55751 10.2715C8.49744 10.1675 8.38677 9.97377 8.33064 9.95378ZM12.7725 9.95247C12.7274 9.97051 12.6167 10.1646 12.5565 10.2702C12.4308 10.491 12.3116 10.701 12.1175 10.7552C11.8689 10.8246 11.6979 10.6054 11.5613 10.429C11.508 10.3624 11.412 10.2356 11.3696 10.2272C11.3451 10.2536 11.326 10.4133 11.3164 10.498C11.2891 10.7203 11.2559 10.9982 11.0043 11.069C10.9457 11.0856 10.8981 11.077 10.8544 11.0521V13.0775C11.2206 13.2053 11.4856 13.5537 11.4856 13.9674V17.7995L14.5701 10.8665C14.5305 10.7721 14.506 10.6703 14.4868 10.5814C14.4472 10.4009 14.4184 10.291 14.3446 10.2702C14.2708 10.248 14.1902 10.3289 14.0645 10.4635C13.9196 10.619 13.7212 10.8328 13.4384 10.7552C13.2456 10.701 13.1252 10.491 12.9994 10.2702C12.9406 10.1661 12.8286 9.97097 12.7725 9.95247Z",
					fill: "url(#paint4_linear_13999_65688)",
					fillOpacity: .24
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter3_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M3.9375 7C2.29688 7.33333 0.984375 14.3334 4.92188 17.6671",
					stroke: "url(#paint5_linear_13999_65688)",
					strokeWidth: .25
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter4_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M5.25 6.00033C5.90625 5.22255 7.54688 3.66699 8.85938 3.66699",
					stroke: "url(#paint6_linear_13999_65688)",
					strokeWidth: .25
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter5_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.7656 22.6663C14.7656 21.4441 14.8969 18.933 15.4219 18.6663C16.0781 18.333 18.0469 17.6663 18.7031 15.333C20.0156 4.66634 12.4688 3.66634 11.1562 3.33301",
					stroke: "url(#paint7_linear_13999_65688)",
					strokeWidth: .25
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter6_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.1094 22.0003C14.1094 20.7781 14.2406 18.267 14.7656 18.0003C15.4219 17.667 17.3906 17.0003 18.0469 14.667C19.3594 4.00033 11.8125 3.00033 10.5 2.66699",
					stroke: "url(#paint8_linear_13999_65688)",
					strokeWidth: .25
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter7_f_13999_65688)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.7656 23.0003C14.7656 22.1114 14.8969 20.2003 15.4219 19.667C15.9469 19.1337 16.9531 18.1114 17.3906 17.667",
					stroke: "url(#paint9_linear_13999_65688)",
					strokeWidth: .25
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_13999_65688",
			x: .375,
			y: 1.08301,
			width: 20.25,
			height: 25.166,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 1,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_13999_65688",
			x: 5.32812,
			y: 9.34961,
			width: 10.4572,
			height: 14.6377,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .125,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_g_13999_65688",
			x: 3.57812,
			y: 7.59961,
			width: 13.9572,
			height: 18.1377,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feTurbulence", {
					type: "fractalNoise",
					baseFrequency: "0.99900001287460327 0.99900001287460327",
					numOctaves: 3,
					seed: 8899
				}),
				/* @__PURE__ */ _jsx("feDisplacementMap", {
					in: "shape",
					scale: 4,
					xChannelSelector: "R",
					yChannelSelector: "G",
					result: "displacedImage",
					width: "100%",
					height: "100%"
				}),
				/* @__PURE__ */ _jsx("feMerge", {
					result: "effect1_texture_13999_65688",
					children: /* @__PURE__ */ _jsx("feMergeNode", { in: "displacedImage" })
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_f_13999_65688",
			x: 1.71106,
			y: 6.37793,
			width: 3.79163,
			height: 11.8848,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .25,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter4_f_13999_65688",
			x: 4.65442,
			y: 3.04199,
			width: 4.70496,
			height: 3.53906,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .25,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter5_f_13999_65688",
			x: 10.7755,
			y: 2.86191,
			width: 8.55522,
			height: 20.1541,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .175,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter6_f_13999_65688",
			x: 10.1192,
			y: 2.1959,
			width: 8.55522,
			height: 20.1541,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .175,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter7_f_13999_65688",
			x: 13.7906,
			y: 16.7291,
			width: 4.53911,
			height: 7.1209,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: .425,
					result: "effect1_foregroundBlur_13999_65688"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_13999_65688",
			x1: 4.26562,
			y1: 4.66667,
			x2: 17.6125,
			y2: 18.7903,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#FBE08E",
					stopOpacity: .6
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#F97316",
					stopOpacity: .7
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEEADC",
					stopOpacity: .7
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_13999_65688",
			x1: .984375,
			y1: 3,
			x2: 15.7259,
			y2: 23.4475,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopOpacity: 0 }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopOpacity: .12
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: .12
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_13999_65688",
			x1: 7.21875,
			y1: 25.0003,
			x2: 13.2279,
			y2: 31.5729,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DEDEDE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5E5E5E"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_13999_65688",
			x1: 10.5567,
			y1: 9.59961,
			x2: 10.5567,
			y2: 25.7376,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F97316" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EAB308",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_13999_65688",
			x1: 10.5567,
			y1: 9.59961,
			x2: 10.5567,
			y2: 25.7376,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F97316" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EAB308",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_13999_65688",
			x1: 8.53125,
			y1: 6.77637,
			x2: 1.5221,
			y2: 14.3331,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494985,
					stopColor: "white"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_13999_65688",
			x1: .211831,
			y1: 3.61807,
			x2: .649548,
			y2: 6.6295,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494985,
					stopColor: "white"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_13999_65688",
			x1: 12.4688,
			y1: 3.99967,
			x2: 20.8942,
			y2: 9.5743,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494985,
					stopColor: "white"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint8_linear_13999_65688",
			x1: 11.8125,
			y1: 3.33366,
			x2: 20.6424,
			y2: 6.41791,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: 0
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494985,
					stopColor: "white"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint9_linear_13999_65688",
			x1: 15.2131,
			y1: 17.8509,
			x2: 18.0602,
			y2: 19.08,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F9D6A2" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494985,
					stopColor: "#F9D6A2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F9D6A2",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13999_65688",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 32,
				fill: "white"
			})
		})
	] })]
});
export default SvgLightbulbLight;
